import React from "react";
import { AddCircleOutline } from "@mui/icons-material";
import { useSimpleFormIteratorItem } from "react-admin";

export const AddOrganization = (props: { onClick: (id: number) => void }) => {
  const { onClick } = props;

  const { index } = useSimpleFormIteratorItem();

  return <AddCircleOutline onClick={() => onClick(index)} />;
};
